import { RefObject } from "react";
import { useTranslation } from "react-i18next";
import { LowerBracket } from "../../interfaces/api/LowerBracket";
import { ProductType } from "../../shared/enums/ProductType";
import { productHelper } from "../../shared/helpers/productHelper";
import { useMarket } from "../../store/hooks/useMarket";
import ListDesktop from "../shared/ListTable/ListDesktop";
import ListItem from "../shared/ListTable/ListItem";
import ListItemBadge from "../shared/ListTable/ListItemBadge";
import ListItemImage from "../shared/ListTable/ListItemImage";
import ListMobile from "../shared/ListTable/ListMobile";
import ListRow from "../shared/ListTable/ListRow";
import ListTable from "../shared/ListTable/ListTable";
import "./LowerBrackets.scss";
import ProductSeperator from "./ProductSeperator";
import "./LowerBrackets.scss";

interface LowerBracketsProps {
  lowerBrackets: LowerBracket[];
  onChange(lowerBracket: LowerBracket): void;
  refLowerBrackets: RefObject<HTMLDivElement>;
  selectedLowerBracket: LowerBracket;
}

const LowerBrackets = ({
  lowerBrackets,
  onChange,
  refLowerBrackets,
  selectedLowerBracket,
}: LowerBracketsProps) => {
  const market = useMarket();
  const { t } = useTranslation("machinefixings");
  if (!lowerBrackets || lowerBrackets.length === 0) {
    return <></>;
  }

  const isSelected = (lowerBracketId: number) => {
    if (!selectedLowerBracket) {
      return false;
    }

    return selectedLowerBracket.id === lowerBracketId;
  };

  return (
    <div ref={refLowerBrackets}>
      <ProductSeperator />
      <h3>
        {t("toolattachment.choosetoolattachment")}
        <sup>* </sup>
      </h3>

      <ListTable>
        {lowerBrackets.map((lowerBracket) => {
          const productData = productHelper.getProductData({
            market,
            product: lowerBracket,
            productType: ProductType.LowerBrackets,
            t,
          });

          return (
            <ListRow
              key={lowerBracket.id}
              isSelected={isSelected(lowerBracket.id)}
              identifier={lowerBracket.id.toString()}
              object={lowerBracket}
              onChange={(object) => {
                onChange(object as LowerBracket);
              }}
            >
              <>
                <ListDesktop
                  readMeText=""
                  readMeUrl=""
                >
                  <ListItemImage  product={productData} />
                  <ListItem
                    label={productData.nameLabel}
                    minWidth="110px"
                    value={productData.name}
                  />
                  {productData.properties.map((property, index) => {
                    return (
                      <ListItem
                        key={`property-${index}`}
                        label={property.label}
                        minWidth="110px"
                        value={property.text}
                      />
                    );
                  })}
                  {lowerBracket.recommendedLowerbracket && (
                    <ListItemBadge text={`${t("recommended")}`} />
                  )}
                </ListDesktop>
                <ListMobile
                  content=""
                  imageLink={lowerBracket.imageLink}
                  isRecommended={lowerBracket.recommendedLowerbracket}
                  isSelected={isSelected(lowerBracket.id)}
                  object={lowerBracket}
                  onChange={(object) => {
                    onChange(object as LowerBracket);
                  }}
                  preContent={`${t("toolattachment.toolattachment")}`}
                  readMeText=""
                  readMeUrl=""
                  title={lowerBracket.name}
                />
              </>
            </ListRow>
          );
        })}
      </ListTable>
    </div>
  );
};
export default LowerBrackets;
